import { render, staticRenderFns } from "./qr-shelf-cover.vue?vue&type=template&id=27a23666"
import script from "./qr-shelf-cover.vue?vue&type=script&lang=js"
export * from "./qr-shelf-cover.vue?vue&type=script&lang=js"
import style0 from "./qr-shelf-cover.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports